<!-- One part of the assessment at a time; each part is given its own form group, so a part is complete on its own -->
<form [formGroup]="form" (submit)="$event.preventDefault()">
  @switch (part()) {
    @case ('presenting') {
      <cia-step-presenting
        [group]="presentingForm"
        [interventionId]="interventionId() ?? initialValue()?.interventionId ?? null"
        [lookups]="lookups()"
        [readOnly]="readOnly()" />
    }
    @case ('clinical') {
      <cia-step-background [group]="clinicalBackgroundForm" [lookups]="lookups()" [readOnly]="readOnly()" />
    }
    @case ('functional') {
      <cia-step-functional
        [group]="functionalRiskForm"
        [state]="state"
        [riskScreener]="riskScreener()"
        [lookups]="lookups()"
        [readOnly]="readOnly()" />
    }
    @case ('treatment') {
      <cia-step-treatment [group]="treatmentForm" [lookups]="lookups()" [readOnly]="readOnly()" />
    }
  }
</form>
